/* eslint-disable */
export const en = {
    'QR код': 'QR code',
    Бейдж: 'Badge',
    'Виджет с картой': 'Widget with map',
    Кнопка: 'Button',
    Ссылка: 'Link',
    'widgetgenerator.erip.tooltip':
        "It's a special code generated and assigned to every ad published online. This code is public, meaning it's available to all users on the web, and is embedded in the link parameters. You can find ERID in your Yandex Distribution <a href='https://distribution.yandex.ru/v2/create/partner/go?utm_source=widget_generator'>account</a>",
    'widgetgenerator.legal.url.yandex': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.legal.url.yango': 'https://yandex.com/legal/taxi_api',
    'widgetgenerator.modal.continue': 'Continue',
    'widgetgenerator.modal.message':
        'The "Widget with map" widget type is not supported for this address, please use a different widget format',
    'widgetgenerator.yandex.badge.orderInYandex': 'Request with Yandex Go',
    'widgetgenerator.yandex.defaultAddress': 'Moscow, Russian Federation, 16 Lva Tolstogo St.',
    'widgetgenerator.yango.badge.getRidetitle': 'Request ride',
    'widgetgenerator.yango.badge.orderInYango': 'Request with Yango',
    'widgetgenerator.yango.defaultAddress':
        'Deira, Dubai, United Arab Emirates, Dubai International Airport',
    Адрес: 'Address',
    'Адрес сайта или CLID партнерской программы': 'Site address or partner program CLID',
    'Без адреса': 'No address',
    Бизнес: 'Business',
    'Введите авторизационные данные для доступа к API. Получить их можно':
        'Enter credentials to access the API. You can get them',
    'Вызвать такси': 'Request ride',
    'Генератор виджета': 'Widget generator',
    'Доехать на такси': 'Get a ride',
    Заголовок: 'Title',
    Загрузить: 'Upload',
    Комфорт: 'Comfort',
    Копировать: 'Copy',
    Куда: 'To',
    'Маршрут, встроенный в ссылку': 'Route embedded in the link',
    Минивен: 'Minivan',
    'Нажимая «Получить код» вы соглашаетесь с': 'By pressing "Get code", you agree to accept the',
    'Невозможно выбрать тариф: регион не поддерживается':
        'Service class unavailable: region not supported',
    'Неправильный адрес': 'Invalid address',
    'Новый виджет': 'New widget',
    Откуда: 'From',
    Подзаголовок: 'Subtitle',
    'Получить код': 'Get code',
    'Скачать QR код': 'Download QR code',
    'Скопируйте код и установите на сайте': 'Copy the code and embed it on your site',
    Стиль: 'Style',
    Стоимость: 'Price',
    Тариф: 'Service class',
    'Текст успешно скопирован': 'Text copied',
    'Указанный адрес': 'Entered address',
    'Фоновое изображение': 'Background image',
    Цена: 'Price',
    Эконом: 'Economy',
    'Это поле обязательно': 'Required field',
    'оставив заявку': 'by submitting a request',
    'условиями использования': 'Terms of Use',
};
